// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.toc-tick {
  color: green;
}
.toc-cross {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/TickOrCross.vue"],"names":[],"mappings":";AAgBA;EACE,YAAY;AACd;AAEA;EACE,UAAU;AACZ","sourcesContent":["<template>\n  <CygnusIcon :name=\"tick ? 'check-circle' : 'x-circle'\" variant=\"solid\" :class=\"tick ? 'toc-tick' : 'toc-cross'\" />\n</template>\n\n<script setup>\nconst props = defineProps(\n    {\n      tick: {\n        type: Boolean,\n        required: true\n      }\n    }\n)\n</script>\n\n<style>\n.toc-tick {\n  color: green;\n}\n\n.toc-cross {\n  color: red;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
